import React from 'react';
import { Button } from './ui/button';
import { Users, Wrench, UserCircle } from 'lucide-react';

const QuoteTargetSelector = ({ quoteTarget, setQuoteTarget, userRole }) => {
  // Only show for ZKTeco staff (admin, zkteco, zkteco_admin)
  const isZKTecoStaff = ['admin', 'zkteco', 'zkteco_admin'].includes(userRole);
  
  if (!isZKTecoStaff) return null;

  return (
    <div className="mb-6 p-4 bg-slate-50 rounded-lg border border-slate-200" data-testid="quote-target-selector">
      <p className="text-sm font-medium text-slate-700 mb-3">Who is this quote for?</p>
      <div className="flex gap-2 flex-wrap">
        <Button
          variant={quoteTarget === 'distributor' ? 'default' : 'outline'}
          size="sm"
          onClick={() => setQuoteTarget('distributor')}
          className="gap-1.5"
          data-testid="quote-target-distributor"
        >
          <Users className="h-3.5 w-3.5" />
          Distributor
        </Button>
        <Button
          variant={quoteTarget === 'installer' ? 'default' : 'outline'}
          size="sm"
          onClick={() => setQuoteTarget('installer')}
          className="gap-1.5"
          data-testid="quote-target-installer"
        >
          <Wrench className="h-3.5 w-3.5" />
          Installer
        </Button>
        <Button
          variant={quoteTarget === 'end_user' ? 'default' : 'outline'}
          size="sm"
          onClick={() => setQuoteTarget('end_user')}
          className="gap-1.5"
          data-testid="quote-target-end-user"
        >
          <UserCircle className="h-3.5 w-3.5" />
          End User
        </Button>
      </div>
      {quoteTarget && (
        <p className="text-xs text-slate-500 mt-2">
          {quoteTarget === 'distributor'
            ? 'Showing distributor and installer pricing columns.'
            : quoteTarget === 'installer'
            ? 'Showing installer pricing column.'
            : 'Showing end user pricing column.'}
        </p>
      )}
    </div>
  );
};

export default QuoteTargetSelector;
